import { render, staticRenderFns } from "./ManageDiagnosis.vue?vue&type=template&id=ac675058&"
import script from "./ManageDiagnosis.vue?vue&type=script&lang=js&"
export * from "./ManageDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports